<template>
  <div>
    <div
      class="h6 text-center rounded text-white px-0 bg-azul-medio w-100 mb-5 pb-2"
    >
      <div class="form-group">
        <div class="gilmer text-uppercase h5 pt-3 font-weight-bold">
          ¿Aún no tienes cuenta?
        </div>
        <p for="run" class="m-3 text-justify h5">
          Regístrate para crear tu usuario como apoderado, así estarás listo
          para postular cuando se inicie el proceso. Si ya te registraste en
          años anteriores, o ya cuentas con un IPA no es necesario que lo
          vuelvas a realizar.
        </p>
        <a
          href="#"
          @click.prevent="$router.push({ name: 'Registro' })"
          class="btn btn-azul-outline text-uppercase gilmer my-3 font-weight-bold px-4"
          >REGISTRARME</a
        >
      </div>
      <!--router-link
        data-testid="button-olvido-contrasena"
        to="olvido-contrasena"
        class="font-weight-bold text-white subrayado"
        >Olvid&eacute; mi contrase&ntilde;a</router-link
      -->
    </div>
    <div
      class="h6 text-justify rounded text-white px-0 bg-azul-medio w-100 mt-5 px-2 py-4"
    >
      <p class="m-3 h5">
        Si eres ciudadano extranjero y no cuentas con RUN chileno, obtén tu
        Identificador Provisorio del Estudiante (IPE) o tu Identificador
        Provisorio del Apoderado (IPA) para poder postular.
      </p>
      <div class="row">
        <a
          href="https://ayudamineduc.cl/tramites-en-linea"
          target="_blank"
          class="btn btn-azul-outline text-uppercase gilmer my-3 font-weight-bold px-4 mx-auto"
          >Obtener IPE e IPA</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Inicio/InicioRegistro.vue